module.exports = __webpack_public_path__ + "img/01_full.eaaaece4.jpg";